module.exports = __webpack_public_path__ + "img/whatsapp.db2867c2.png";